import { Controller } from "@hotwired/stimulus"

// Toggles a note between its static text and an inline edit form. While the
// form is open the card opts out of morph refreshes — a mid-edit refresh would
// otherwise snap the form shut and reset its classes. Saving submits the
// ticket update; the redirect's morph then delivers the new text (editing is
// cleared first, so the card morphs again).
export default class extends Controller {
  static targets = ["display", "form", "input"]

  connect() {
    this.editing = false

    this.guard = (event) => {
      if (this.editing) event.preventDefault()
    }
    this.element.addEventListener("turbo:before-morph-element", this.guard)

    this.settle = (event) => {
      if (event.detail.success) this.cancel()
    }
    this.element.addEventListener("turbo:submit-end", this.settle)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-morph-element", this.guard)
    this.element.removeEventListener("turbo:submit-end", this.settle)
  }

  edit() {
    if (!this.hasFormTarget) return
    this.editing = true
    this.displayTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    const input = this.inputTarget
    input.focus()
    // place the caret at the end
    input.setSelectionRange(input.value.length, input.value.length)
  }

  cancel() {
    if (!this.hasFormTarget) return
    this.editing = false
    this.formTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
  }
}
